// =========================================================================
// MOTOR DE TEMAS DE CONVERSA UNIFICADO (CONVERSATION THEME ENGINE)
// =========================================================================
// Este arquivo gerencia os designs visuais do Inbox e do Kanban.
// Para alternar o design ativo, basta alterar o valor de CURRENT_THEME!
// =========================================================================

import { computed } from 'vue';

// 🎨 TEMA ATIVO ATUALMENTE:
// Opções disponíveis no catálogo:
// - 'whatsapp_dark'     -> Design Oficial WhatsApp Dark (Recomendado)
// - 'chatwoot_default'  -> Design Original do Chatwoot (Fallback Limpo)
export const CURRENT_THEME = 'whatsapp_dark';

// 📚 CATÁLOGO DE TEMAS SALVOS
export const SAVED_THEMES = {
  whatsapp_dark: {
    id: 'whatsapp_dark',
    name: 'WhatsApp Oficial Dark',
    description: 'Fundo escuro pontilhado (#0b141a), balões verdes (#005c4b) e cinzas (#202c33), duplo check azul e figurinhas.',
    cssClass: 'theme-conversation-whatsapp-dark',
    features: {
      enableStickers: true,
      enableCustomWallpaper: true,
      bubbleStyle: 'whatsapp',
    },
  },
  chatwoot_default: {
    id: 'chatwoot_default',
    name: 'Chatwoot Original Padrão',
    description: 'Visual 100% nativo do Chatwoot sem modificações visuais de tema.',
    cssClass: '',
    features: {
      enableStickers: false,
      enableCustomWallpaper: false,
      bubbleStyle: 'chatwoot',
    },
  },
};

/**
 * Composable para usar o tema ativo em qualquer componente (Inbox ou Kanban)
 */
export function useConversationTheme() {
  const activeTheme = computed(() => {
    return SAVED_THEMES[CURRENT_THEME] || SAVED_THEMES.chatwoot_default;
  });

  const themeClass = computed(() => activeTheme.value.cssClass);
  const themeFeatures = computed(() => activeTheme.value.features);

  return {
    currentThemeId: CURRENT_THEME,
    activeTheme,
    themeClass,
    themeFeatures,
    allThemes: SAVED_THEMES,
  };
}
